import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@max/auth/services/auth.service';
import { SharedConfirmData } from '@max/shared/components/modals/confirmation-data.model';
import { MvdModalService } from '@max/shared/services/modal/mvd-modal.service';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { DriverTsaSecurityThreat } from '../../models/driver-tsa-security-threat.model';
import { DriverTsaSecurityThreatService } from '../../services/driver-tsa-security-threat.service';
import { TsaSecurityThreatHistoryModalComponent, TsaSecurityThreatHistoryModalContext } from '../tsa-security-threat-history-modal/tsa-security-threat-history-modal.component';

@Component({
    selector: 'tsa-security-threat-history',
    templateUrl: './tsa-security-threat-history.html'
})
export class TsaSecurityThreatHistoryComponent extends BaseComponent implements OnInit {

    public history: DriverTsaSecurityThreat[];
    public filteredHistory: DriverTsaSecurityThreat[];
    public hasDeletePrivilege: boolean;

    @Input() public customerNumberId: number;

    @Input() public editorEnabled: boolean;

    @Input() public showHistoryEnabled: boolean;


    constructor(private driverTsaSecurityThreatService: DriverTsaSecurityThreatService,
        private modalService: MvdModalService,
        private authService: AuthService) {
        super();

        this.hasDeletePrivilege = authService.hasACSTransactionClaimEx(authService.acsTransactionClaim, 'DeleteTSAResponse');
    }

    public ngOnInit() {
        this.loadHistory();
    }

    public loadHistory = (): void => {

        this.driverTsaSecurityThreatService.getHistory(this.customerNumberId)
            .subscribe(
                r => {
                    this.history = r.result;
                    this.filteredHistory = this.filterHistory(this.history);
                },
                e => this.handleValidationResult(e));
    };

    private filterHistory(history: DriverTsaSecurityThreat[]) {

        if (!!history && history.length > 0) {
            return history.filter(h => h.driverTSASecurityThreatSourceTypeId != 2);
        }

        return [];
    }

    public openDeleteConfirmationModal(row: DriverTsaSecurityThreat) {
        const confirmData = new SharedConfirmData();
        confirmData.title('Confirm');
        confirmData.body('Are you sure you want to delete this record?');
        confirmData.cancelBtn('No');
        confirmData.okBtn('Yes');
        this.modalService.confirmModal(confirmData).afterClosed()
            .subscribe(confirmed => {
                if (confirmed) {
                    this.deleteRecord(row.id);
                }
            });
    }

    private deleteRecord(id: number) {
        this.driverTsaSecurityThreatService.deleteSecurityThreat(id)
            .subscribe(
                _ => this.loadHistory(),
                e => this.handleValidationResult(e)
            );
    }

    public showHistory = (): void => {
        let data = new TsaSecurityThreatHistoryModalContext(this.customerNumberId);

        this.modalService.open(TsaSecurityThreatHistoryModalComponent, data);
    };

}
